import React from 'react';
import ErrorIcon from '../../assets/add-ons/exclamation.svg';
import './index.css';

export const Input = (props) => (
  <div className="custom-input-field">
    <label htmlFor={props.id}>
      {props.children}
      {props.required ? <span className="custom-input-field--required"> *</span> : null}
    </label>
    <div className="custom-input-container">
      {props.icon && props.icon()}
      <input
        id={props.id}
        type={props.type ? props.type : 'text'}
        autoComplete="off"
        value={props.value}
        onChange={props.onChange}
        maxLength={props.maxLength}
        placeholder={props.placeholder ? props.placeholder : null}
        className={props.className ? props.className : 'custom-input'}
        readOnly={props.readOnly}
        min={props.min ? props.min : undefined}
        onKeyDown={props.onKeyDown ? props.onKeyDown : undefined}
      />
      {props.isPercentage ? <span className="percent">%</span> : null}
    </div>

    {props.isError
      ? <div className="error__label">
          <ErrorIcon />
          <span>{props.errorMessage}</span>
        </div>
      : null
    }
  </div>
);
